/**
 * Pozele și notițele pentru stack.
 *
 * Format poze: 1080x1080 px, JPEG, calitate 80%, sRGB.
 * Pentru a schimba o notiță, modifică direct câmpul `note` de mai jos.
 *
 * Total: 34 poze. Ultima rămâne mereu „Până la capăt".
 */

export interface PhotoData {
  id: number
  src: string
  note: string
  rotation: number
}

interface PhotoInput {
  src: string
  note: string
}

const inputs: PhotoInput[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/dqMteECeH2Xm1Saf5uBTfJ/Poze_Cata_0000s_0000_01.jpg',
    note: 'După costume',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/7LUUN926qNNXdnfa5qFtH5/Poze_Cata_0000s_0001_02.jpg',
    note: 'Departe de Dom',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/jSN8N7ejjDc44UEx8hCw3f/Poze_Cata_0000s_0002_03.jpg',
    note: 'Mesaje secrete',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/bhaEyMAJ4YUaTjkmX7D1js/Poze_Cata_0000s_0003_04.jpg',
    note: 'Prea cool pentru soare',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/hhUvZUST2nkw8gasReC2hA/Poze_Cata_0000s_0004_05.jpg',
    note: 'Pe scară călare',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/pj6aawhj8Xxz9r6CAJPmdv/Poze_Cata_0000s_0029_28-1.jpg',
    note: 'Iar mi-am scăpat *** în ***',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/viqy3pS3YMGuBEWhLTdXkn/Poze_Cata_0000s_0005_06.jpg',
    note: 'Pelicanul meu!?',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/fK8CNA5VdMQq3Vh6Qv2m8K/Poze_Cata_0000s_0006_07.jpg',
    note: 'Michelin',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/7jdpUtXDyRZUSxFmQg4Fmt/Poze_Cata_0000s_0007_08.jpg',
    note: 'Te învăț eu!',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/kiiEaxP7h2uw98xjvebJ1X/Poze_Cata_0000s_0008_09.jpg',
    note: 'Marica',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/qYREkWLcjyLnfrvwgL2GZp/Poze_Cata_0000s_0009_10.jpg',
    note: 'Marica în Alpi',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/2QA7cWeRWPRL6Wqrw4MAme/Poze_Cata_0000s_0030_28-2.jpg',
    note: 'Dacopații',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/jtQeh9H6oe3q7am9Zs2Yvn/Poze_Cata_0000s_0010_11.jpg',
    note: 'Mădă e aproape',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/dHiwtHxBFFP2zPqkNtP9Zw/Poze_Cata_0000s_0011_12.jpg',
    note: 'Încă un Focșani',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/3zzw6KFJBWA94BJar5jCrp/Poze_Cata_0000s_0012_13.jpg',
    note: 'Viena. Alex o dădea.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/77CA8t1EMtTmsociimmAZZ/Poze_Cata_0000s_0013_14.jpg',
    note: 'Lasă-mă',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/qDRQToLMEGBnEGaUDXfCoh/Poze_Cata_0000s_0014_15.jpg',
    note: 'Nuntă',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/tZdRvkogma12VGuVGrvdBx/Poze_Cata_0000s_0031_28-3.jpg',
    note: 'Aproape toți',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/rSGJGLSq21rxm8PsDxoccq/Poze_Cata_0000s_0015_16.jpg',
    note: 'Coșurile mele',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/dAJFpQVVwWcZNHMp5268wd/Poze_Cata_0000s_0016_17.jpg',
    note: 'Spre dimineață',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/t9QwMB6gaLHxcak4C2o1Ao/Poze_Cata_0000s_0017_18.jpg',
    note: 'Buzău',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/4pWbZNTYD1w7tnuB2v6bYm/Poze_Cata_0000s_0018_19.jpg',
    note: 'Sigur că puteți pescui',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/e3GwXscftSdQd1mxGqfiCy/Poze_Cata_0000s_0019_20.jpg',
    note: 'Măăă',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/bzrTm9i15gKGiSx8AbNMAu/Poze_Cata_0000s_0032_28-4.jpg',
    note: 'Cadrul perfect',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/wwFFPeHGq8vDJcPSq9sj51/Poze_Cata_0000s_0020_21.jpg',
    note: 'Ne-ai făcut paste',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/qyPZAJ1eo4pfeBiB1xktT9/Poze_Cata_0000s_0021_22.jpg',
    note: 'Ce să mai zici',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/cVwu2LJiF2dW3s4MfEZxzb/Poze_Cata_0000s_0022_23.jpg',
    note: 'Slăbănogi',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/9m3Wbad5wo6xfNmPFGLGgL/Poze_Cata_0000s_0023_24.jpg',
    note: 'Înapoi de la Buzău',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/kAUYnNrxxvAX2zKtyX9aev/Poze_Cata_0000s_0024_25.jpg',
    note: 'Faba',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/t3XbeBqQNJUCUPGKkJZfBF/Poze_Cata_0000s_0033_28-5.jpg',
    note: 'Vadim în Deltă',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/suzcwFXB4RA25UFMmUc9Zq/Poze_Cata_0000s_0025_26.jpg',
    note: 'Los Perros: Origins',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/nJ8hrnqBQejF86Mrr9HeQp/Poze_Cata_0000s_0026_27.jpg',
    note: 'Prea mult soare',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/kLre4NnRe1uZQUUAypKQqh/Poze_Cata_0000s_0027_28.jpg',
    note: 'Ceva fin',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/fpESJVDQNmQx3EhkR2XCFX/Poze_Cata_0000s_0028_29.jpg',
    note: 'Până la capăt',
  },
]

export const photos: PhotoData[] = inputs.map((input, index) => {
  const seed = (index * 137) % 10
  const rotation = seed - 5

  return {
    id: index + 1,
    src: input.src,
    note: input.note,
    rotation,
  }
})
